
import React, { Component } from 'react'
import CreatePriority from './CreatePriority'
import ViewPriority from './ViewPriority'
import { getCookie } from "../../../helpers/cookieHelper";
import { Messager } from 'rc-easyui';
import { getPriorityID } from '../TicketingDetail/TicketAPI';

export default class Priority extends Component {
    constructor() {
        super()
        this.childRef = React.createRef()
        this.state = {
            pri: {
                priority: "",
            },
            priorityList: [],
            rules: {
                priority: ['required'],
            },
            operation: "Add",
            selected: {},
            permissions: [],
        }

    }
    componentDidMount = async () => {
        var data = getCookie('permission');
        this.setState({
            permissions: JSON.parse(data),
            priorityList: await getPriorityID()
        });
    }
    OnEditClick = (row) => {
        this.setState({
            pri: row,
            operation: 'update'
        })
    }


    handleInput = (name, value) => {
        const newArr = { ...this.state.pri }
        newArr[name] = value
        this.setState({
            pri: newArr

        })

    }

    render() {
        const { permissions } = this.state;

        return (
            <div>
                <Messager ref={ref => this.messager = ref}></Messager>

                <div className='container-fluid'>
                    <div className='row'>
                        {permissions.includes("project-create") ? (
                            <div className='col-4'>


                                <CreatePriority
                                    pri={this.state.pri}
                                    handleInput={this.handleInput}
                                    operation={this.state.operation}
                                    rules={this.state.rules}
                                    ref={this.childRef}
                                    formClear={this.formClear}
                                />
                            </div>
                        ) : null}
                        {permissions.includes("project-view") ? (
                            <div className='col-8'>
                                <ViewPriority

                                    OnEditClick={this.OnEditClick}
                                    onSelectionChange={this.onSelectionChange}
                                    selectedRow={this.state.selected}
                                    permissions={this.state.permissions}

                                />
                            </div>
                        ) : null}

                    </div>
                </div>

            </div>
        )
    }
}
